import React from 'react'
import config from 'config'

import withApolloProvider from 'components/hocs/withApolloProvider'
import RichCta from 'components/rich-cta'
import WidgetPage from 'components/hocs/widget-page'
import useActiveLenders from 'components/hooks/useActiveLenders'

export const RichCtaApp = (props) => {
  const lendersList = useActiveLenders('refi')
  const lendersCount = lendersList.length

  return (
    <RichCta
      url={`${config.credibleRoot}/refinance-student-loans`}
      title="Easily refinance your student loans."
      body={`Compare rates from up to ${lendersCount} lenders in minutes.`}
      ctaText="Get Started"
      {...props}
    />
  )
}

export default WidgetPage(withApolloProvider(RichCtaApp))
